<app-header></app-header>
<div class="hero-section section pt-0">
    <div class="container pt-5">
 
    </div>
   
  </div>

 
  <div class="about-section section container">
    <div class="row">
      <div class="col-12 col-lg-12 mb-3 mb-lg-0">
        <p class="display-5 fw-normal">Ambasa Coach</p>
        <p >
          We are a luxury coach company that offers both passengers and parcel,We Operate within kenya borders.we operate from Nairobi,mwingi,garissa,madogashe,habaawein,wajir,kutolo,waragadud,Rhamu and mandera..we are the one of the best most recognise bus industry  that play northern part of kenya.we are kenyans favourite transport bus company offering quality,unique services.whatever the journey,whatever the time and place we are committed in serving and providing  you with the best among the rest.we are time keepers,safe,reliable,comfortable,customer friendly,free wife and refreshments.we are the choice for travellers
        </p>
       
      </div>
      
    </div>
  </div>
  <app-footer></app-footer>
  